import { css } from '@emotion/react';
import COLORS from 'shared/styles/colors';
import theme from 'shared/styles/themes';
import { mediaquery } from 'shared/styles/styleFunctions';

export default css({
  '&.creator-collections-actions': {},
  '.creator-collections-actions': {
    '&__toggle': {
      alignSelf: 'flex-end',
    },
  },
});
